import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let inflight = null;

export function useSettings() {
  const [s, setS] = useState(cache || { aura_voice_enabled: false, loaded: false });
  useEffect(() => {
    if (cache) return;
    inflight = inflight || api.get("/public/settings").then((r) => { cache = { ...r.data, loaded: true }; return cache; }).catch(() => ({ aura_voice_enabled: false, loaded: true }));
    inflight.then(setS);
  }, []);
  return s;
}

export const invalidateSettings = () => { cache = null; inflight = null; };
